import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8">选择色影视的五大理由</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
            {featuresData.map((feature) => (
              <div
                key={feature.id}
                className="group flex flex-col items-center text-center p-5 md:p-6 bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/20 transition-all duration-300"
              >
                <span className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-50 text-primary-500 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors mb-4">
                  <i className={`${feature.icon} text-xl md:text-2xl`}></i>
                </span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}